import React from 'react';
import { Briefcase } from 'lucide-react';

const CardFront = ({ profile }) => {
  return (
    <div className="card-face absolute w-full h-full backface-hidden bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 rounded-2xl shadow-xl border border-slate-700/50 p-6 flex flex-col items-center justify-center">
      <div className="relative mb-4">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full blur-lg opacity-50"></div>
        <img 
          src={profile.photo} 
          alt={profile.name}
          className="relative w-28 h-28 rounded-full object-cover border-4 border-slate-700"
        />
      </div>
      <h3 className="text-2xl font-bold text-white mb-1 text-center">{profile.name}</h3>
      <p className="text-blue-400 font-medium mb-2">{profile.role}</p>
      <div className="flex items-center gap-2 text-slate-400 text-sm">
        <Briefcase size={14} />
        <span>{profile.company}</span>
      </div>
      <div className="absolute bottom-4 text-slate-500 text-xs">
        Hover para ver más
      </div>
    </div>
  );
};

export default CardFront;
